import React, {useState} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import {setFilters} from "../JobBoardActions";
import WithOverlay from "../../PageLayout/Popups/withOverlayHoc";
import JobBoardFiltersPopupContent from "./JobBoardFiltersPopupContent";
import JobBoardFiltersPopupResetButton from "./JobBoardFiltersPopupResetButton";
import JobBoardFiltersContext from "./JobBoardFiltersContext";
import {toggleShowJobBoardFiltersPopup} from "./JobBoardFiltersActions";

const JobBoardFiltersPopup = (props) => {

  const {toggleShowJobBoardFiltersPopup, showJobBoardFiltersPopup, setFilters} = props;

  if (!showJobBoardFiltersPopup) {
    return null
  }

  const {filters} = props;
  const [popupFilters, setPopupFilters] = useState([...filters]); // initial value comes from props

  const closePopup = (hideOverlay, saveButton = false) => {
    if (saveButton) {
      setFilters(popupFilters);
    } else {
      setPopupFilters([]);
    }
    hideOverlay(() => { // fade out popup, then remove from redux
      toggleShowJobBoardFiltersPopup(false);
    })
  }

  return (
    <WithOverlay>
      {(hideOverlay) => (
        <JobBoardFiltersContext.Provider value={[popupFilters, setPopupFilters]}>
          <div className="ui-popup jb-filters__popup">
            <div className="ui-popup__header">
            <span className="ui-popup__header-title">
              <FormattedMessage id="jobBoard.filters.popup.title"/>
            </span>
              <button className="ui-popup-header__close" onClick={() => closePopup(hideOverlay)}/>
            </div>
            <div className="ui-popup__body">
              <JobBoardFiltersPopupResetButton/>
              <JobBoardFiltersPopupContent/>
            </div>
            <div className="ui-popup__footer">
              <button className="ui-button5 ui-button5--blue text-uppercase ui-button5--bold" onClick={() => closePopup(hideOverlay)}>
                <FormattedMessage id="messageBox.buttons.cancel"/>
              </button>
              <button className="ui-button5 ui-button5--green text-uppercase ui-button5--bold" onClick={() => closePopup(hideOverlay, true)}>
                <FormattedMessage id="messageBox.buttons.save"/>
              </button>
            </div>
          </div>
        </JobBoardFiltersContext.Provider>
      )}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  const {showJobBoardFiltersPopup, filters} = store.jobBoard;
  return {
    showJobBoardFiltersPopup,
    filters,
  };
};

const mapDispatchToProps = {
  toggleShowJobBoardFiltersPopup,
  setFilters
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobBoardFiltersPopup)
)
